import { VisuallyHidden } from '@reach/visually-hidden'
import PropTypes from 'prop-types'
import { forwardRef } from 'react'
import { FormattedMessage } from 'react-intl'

const buttonClasses = [
  'mobile-menu__close_button',
  'dropdown-item',
  'dropdown-toggle',
  'btn',
  'btn-none'
].join(' ')

const CloseButton = forwardRef(({ onClick, isShowing }, ref) => (
  <button
    aria-expanded={isShowing}
    className={buttonClasses}
    data-action='Toggle'
    data-testid='mobile-menu-toggle'
    id='mobile-menu-dropdown-close'
    onClick={onClick}
    ref={ref}
  >
    <VisuallyHidden>
      <FormattedMessage id='header.close_menu' />
    </VisuallyHidden>
    <img alt='' src={require(`/app/assets/images/close-icon-black.svg`)} />
  </button>
))

export default CloseButton

CloseButton.propTypes = {
  isShowing: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
}
